import React, { useEffect, useRef, useState } from 'react';

const SafeIframe = ({ children, className, style, title, bodyStyle = {}, bodyClass = '', allowOpenLinks = false }) => {
  const ref = useRef();
  const [height, setHeight] = useState('0px');

  const onLoad = () => {
    setHeight(ref.current?.contentWindow.document.body.scrollHeight + 'px');
  };

  useEffect(() => {
    onLoad();
  }, []);

  return (
    <iframe
      ref={ref}
      title={title}
      className={className}
      srcDoc={`<!DOCTYPE html><html><head>
        <link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet" />
        <style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');
          body { margin: 0; padding: 0; box-sizing: border-box; width: 100%; font-family: "Poppins", sans-serif; overflow: hidden; }
          html { width: 100%; overflow: hidden; } 
        </style></head><body class="${bodyClass}" style="width: 100%; font-family: Poppins; ${Object.entries(
          bodyStyle
        ).reduce((a, [key, value]) => {
          a += `${key}: ${value};`;
          return a;
        }, '')}">${children}</body></html>`}
      style={{
        ...style,
        border: 'none',
        overflow: 'hidden',
        width: '100%',
      }}
      height={height}
      sandbox={`allow-same-origin${allowOpenLinks ? ' allow-popups allow-popups-to-escape-sandbox' : ''}`}
      onLoad={onLoad}
    />
  );
};

export default SafeIframe;
